const getRecentGamePresentation = (result) => {
  if (result === 'Win') {
    return {
      label: 'Kazandı',
      className: 'bg-green-100 text-green-800'
    };
  }

  if (result === 'Draw') {
    return {
      label: 'Berabere',
      className: 'bg-yellow-100 text-yellow-800'
    };
  }

  return {
    label: 'Kaybetti',
    className: 'bg-red-100 text-red-800'
  };
};

module.exports = { getRecentGamePresentation };
